import { defaultConfig, defineSlotRecipe } from '@chakra-ui/react';

import merge from 'lodash/merge';

export const accordionSlotRecipe = defineSlotRecipe(
    merge(defaultConfig?.theme?.slotRecipes?.accordion, {
        variants: {
            variant: {
                outline: {
                    item: {
                        borderColor: 'bg.muted',
                    },
                    itemTrigger: {
                        _active: {
                            bgColor: 'bg.muted',
                        },
                    },
                    itemIndicator: {
                        color: 'fg.900',
                    },
                    itemBody: {
                        pb: 0,
                    },
                },
            },
        },
    }),
);
